import { IconButton, styled, Typography } from "@mui/material";
import React, {
  ReactNode,
} from "react";
import {
  Box,
} from "@mui/material";
import SignatureName from "../signature-name/SignatureName";
import {
  gaps,
} from "theme/defaultStyle";
import CloseIcon from "theme/icons/CloseIcon";

type Props = {
  title: string;
  showSignatureName?: boolean;
  justifyContent?: string;
  width?: number;
  children: ReactNode;
  onClose?: () => void; // ✅ add this
};

type BodyInnerProps = {
  width: number;
};

const BodyInner = styled("div")(({ width }: BodyInnerProps) => ({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
  width: width,
}));

export default function SignatureDialogBody({
  title,
  showSignatureName = false,
  justifyContent = "space-between",
  width = 500,
  children,
  onClose, // ✅ grab it
}: Props) {
  return (
    <BodyInner width={width}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{title}</Typography>
        {onClose && (
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      {showSignatureName ? <SignatureName /> : null}
      {children}
    </BodyInner>
  );
}

